/* MTX Elite — Collection description collapse
 *
 * The brand description on collection pages was pushing products below
 * the fold. CSS clamps the text to ~2 lines by default; this script
 * (a) un-hides the "Read more" button only when the text actually
 * overflows the clamp, and (b) toggles the expanded state on click.
 *
 * Short descriptions render fully with no button — no UI clutter.
 * Re-runs on Shopify section:load so the theme editor updates live.
 */
(function () {
  function init(scope) {
    var root = scope || document;
    var wrappers = root.querySelectorAll('[data-collection-description]');
    wrappers.forEach(function (wrapper) {
      if (wrapper.dataset.descriptionInitialised === 'true') return;
      wrapper.dataset.descriptionInitialised = 'true';

      var text = wrapper.querySelector('[data-description-text]');
      var toggle = wrapper.querySelector('[data-description-toggle]');
      if (!text || !toggle) return;

      var labelMore = toggle.querySelector('[data-toggle-label-more]');
      var labelLess = toggle.querySelector('[data-toggle-label-less]');

      var measure = function () {
        var collapsed = !wrapper.classList.contains('is-expanded');
        if (!collapsed) return;
        var overflows = text.scrollHeight - text.clientHeight > 1;
        if (overflows) {
          toggle.hidden = false;
          wrapper.classList.add('collection-hero__description--collapsible');
        } else {
          toggle.hidden = true;
          wrapper.classList.remove('collection-hero__description--collapsible');
        }
      };

      // Initial measure after fonts/layout settle.
      if (document.readyState === 'complete') {
        measure();
      } else {
        window.addEventListener('load', measure, { once: true });
      }
      // Re-measure on resize (debounced) — wrap width affects line count.
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(measure, 150);
      });

      toggle.addEventListener('click', function () {
        var expanded = wrapper.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (labelMore) labelMore.hidden = expanded;
        if (labelLess) labelLess.hidden = !expanded;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  // Shopify theme editor live-reload hook.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
